import { SKU } from './sku';

export type Site = {
  _id: string;
  createdAt: Date;
  updatedAt: Date;
  name: string;
  code: string;
  address: {
    state: string;
    city: string;
    zip: string;
    addressLine1: string;
    addressLine2: string;
    fullAddress?: string;
  };
  admin: string;
  operator: string;
  type: string;
  washHub: string;
  deliveryInstructions: string;
  pickupInstructions?: string;
  deliveryDayOfTheWeek: number;
  deliveryFrequency: string;
  capacity: number;
  siteType: string;
  packages?: string[];
  portal?: boolean;
  portalName?: string;
  logo?: string;
  banner?: string;
  isSuspended?: boolean;
  // invoice per delivery
  invoice?: boolean;
  contract?: string;
  contractDate?: string;
  invoicePerPickup?: boolean;
  invoiceNotes?: string;
  billingDetails?: string;
  pricingDetails?: Array<{
    itemSku: string;
    deliveryPrice: number;
    replacementPrice: number;
    effectiveDate: string;
  }>;
  hasExpirationDate?: boolean;
  hasCokeAdjustment?: boolean;
  contracts?: Array<{
    contract: string;
    _id: string;
    uploadedAt?: string;
  }>;
  website?: string;
  status?: string;
  qrLandingUrl?: string;
};

export type SiteResponse = {
  item: Site;
};

export type CustomerPortal = {
  _id: string;
  name: string;
  washHub: string;
  site: string;
  createdAt: Date;
  updatedAt: Date;
  packages: SKU[];
  logo?: string;
  banner?: string;
};

export enum SiteTypeEnum {
  PERMANENT = 'Permanent',
  SEASONAL = 'Seasonal',
  EVENT = 'Event',
  THIRD_PARTY_WASH = '3rd Party Wash',
}

export enum SiteStatusEnum {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  ARCHIVED = 'archived',
}
